export function sliceToLimit<T>(items: T[], limit: number): T[] {
  return items.slice(0, limit);
}

export function hasMoreThanLimit(total: number, limit: number): boolean {
  return total > limit;
}
